import { gql } from '@apollo/client'

export const sendEmailVerificationMutation = gql`
    mutation sendEmailVerification($userId: Int!) {
        user(id: $userId) {
            sendEmailVerification {
                verificationUrl
                user {
                    id
                }
            }
        }
    }
`
